import { temAcesso } from '@/shared/auth/temAcesso'

const SolicitacoesReaberturas = () => import('./SolicitacoesReaberturas.vue')

export default {
    path: 'solicitacoesReaberturas',
    name: 'Gestores_SolicitacoesReaberturas',
    component: SolicitacoesReaberturas,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GEST-ENTR-06')) {
            next()
        }
    }
}
